import moment from 'moment';
import {
  STATUS_ERROR,
  STATUS_LOADING,
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
} from '../../../../const';
import {
  FETCH_COMPANY_BRANCHES_SUCCESS,
  FETCH_EMPLOYEES_ERROR,
  FETCH_EMPLOYEES_REQUEST,
  FETCH_EMPLOYEES_SUCCESS,
  RESET_EMPLOYEES_FILTERS,
  SET_DATE_RANGE,
  SET_EMPLOYEES_FILTERS,
  SET_EMPLOYEES_SEARCH,
  SET_SCHEDULE_ID,
  SET_EMPLOYEE_SCHEDULE_SUCCESS,
  DOWNLOAD_COMPANY_EMPLOYEES_PAYSLIPS,
  DOWNLOAD_COMPANY_EMPLOYEES_PAYSLIPS_SUCCESS,
  DOWNLOAD_EMPLOYEE_PAYSLIPS,
  DOWNLOAD_EMPLOYEE_PAYSLIPS_SUCCESS,
  FETCH_LAST_SYNC_TIME_SUCCESS,
  FETCH_IS_SYNCING_SUCCESS,
  INIT_EMPLOYEES,
  SET_EMPLOYEES_PAGE_PAGINATION,
  SET_EMPLOYEES_PAGE,
  SET_ALL_EMPLOYEES,
} from '../actions';

const initialState = {
  employeesList: [],
  allEmployeesList: [],
  companyBranches: [],
  status: STATUS_NOT_REQUESTED,
  filters: {
    establishments: '',
    natureEmployments: '',
    classifications: '',
    contracts: '',
  },
  dateRange: {
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
  },
  searchTerm: '',
  chosenScheduleId: '',
  isWaitingModalShow: false,
  isSingleWaitingModalShow: false,
  lastSyncTime: '',
  lastSyncingStatus: false,
};

const initialFilters = {
  filters: {
    establishments: '',
    natureEmployments: '',
    classifications: '',
    contracts: '',
  },
  dateRange: {
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
  },
  searchTerm: '',
  // pagination
  currentPage: 1,
  pages: 0,
  limit: 20,
  total: 0,
};

export const employeesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EMPLOYEES_REQUEST:
      return { ...state, status: STATUS_LOADING };

    case FETCH_EMPLOYEES_SUCCESS: {
      const { data } = action.payload;
      return { ...state, status: STATUS_SUCCESS, employeesList: data };
    }

    case FETCH_LAST_SYNC_TIME_SUCCESS: {
      const { data } = action.payload;
      return { ...state, lastSyncTime: data };
    }

    case FETCH_IS_SYNCING_SUCCESS: {
      const { data } = action.payload;
      return { ...state, lastSyncingStatus: data };
    }

    case FETCH_EMPLOYEES_ERROR:
      return { ...state, status: STATUS_ERROR };

    case SET_EMPLOYEES_FILTERS:
      return { ...state, filters: action.payload };

    case RESET_EMPLOYEES_FILTERS:
      return {
        ...state,
        filters: initialFilters.filters,
        searchTerm: initialFilters.searchTerm,
      };

    case SET_EMPLOYEES_SEARCH:
      return { ...state, searchTerm: action.payload };

    case FETCH_COMPANY_BRANCHES_SUCCESS:
      return { ...state, companyBranches: action.payload };

    case SET_DATE_RANGE:
      return { ...state, dateRange: action.payload };

    case SET_SCHEDULE_ID:
      return { ...state, chosenScheduleId: action.payload };

    case SET_EMPLOYEE_SCHEDULE_SUCCESS: {
      const {
        newSchedule: {
          data: { employeeSchedule },
        },
      } = action.payload;

      const updatedEmployeesList = state.employeesList.map((employee) =>
        employee.employeeid === employeeSchedule.employeeId
          ? { ...employee, ...employeeSchedule }
          : employee
      );

      return {
        ...state,
        employeesList: updatedEmployeesList,
        chosenScheduleId: action.payload,
      };
    }

    case DOWNLOAD_COMPANY_EMPLOYEES_PAYSLIPS:
      return {
        ...state,
        isWaitingModalShow: action.payload.key ?? true,
      };

    case DOWNLOAD_COMPANY_EMPLOYEES_PAYSLIPS_SUCCESS:
      return { ...state, isWaitingModalShow: false };

    case DOWNLOAD_EMPLOYEE_PAYSLIPS:
      return { ...state, isSingleWaitingModalShow: true };

    case DOWNLOAD_EMPLOYEE_PAYSLIPS_SUCCESS:
      return { ...state, isSingleWaitingModalShow: false };

    case INIT_EMPLOYEES:
      return initialState;

    case SET_EMPLOYEES_PAGE_PAGINATION: {
      const { page, pages, limit, total } = action.payload;

      return {
        ...state,
        currentPage: page,
        pages,
        limit,
        total,
      };
    }

    case SET_EMPLOYEES_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ALL_EMPLOYEES:
      return {
        ...state,
        allEmployeesList: action.payload,
      };

    default:
      return state;
  }
};
